import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 405,
  name: 'Method Not Allowed',
  description:
    'The HTTP method used in the request (GET, POST, PUT, DELETE, etc.) is not supported for the target resource. The server knows the resource exists but rejects the specific method.',
  causes: [
    'Sending a POST request to an endpoint that only accepts GET, or vice versa. The API supports the URL but not with that method.',
    'A form submission uses GET instead of POST, or the frontend sends the wrong method due to a misconfigured fetch/axios call.',
    'The server or framework has CORS preflight (OPTIONS) misconfigured, and the actual request method is being rejected.',
  ],
  fixes: [
    'Check the Allow header in the response — it lists which HTTP methods the endpoint accepts. Switch to a supported method.',
    'Review your API documentation to confirm the correct method for each endpoint. REST conventions: GET to read, POST to create, PUT/PATCH to update, DELETE to remove.',
    'If OPTIONS requests fail, ensure your server handles CORS preflight correctly and lists the required methods in Access-Control-Allow-Methods.',
  ],
  monitoringTip:
    'Uptrack sends GET requests by default to check endpoint availability. If your health check endpoint only accepts POST, configure the monitor with the correct HTTP method to avoid false 405 alerts.',
}

export const Route = createFileRoute('/_site/http/405')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
